import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { workOrdersService } from '../services/workOrders.service';
import { toast } from 'sonner';

export function useWorkOrders(projectId?: string) {
  const queryClient = useQueryClient();

  const { data: dbWorkOrders = [], isLoading: isLoadingList, error: listError } = useQuery({
    queryKey: ['work-orders', projectId],
    queryFn: () => workOrdersService.getWorkOrders(projectId),
  });

  const deleteMutation = useMutation({
    mutationFn: (id: string) => workOrdersService.deleteWorkOrder(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['work-orders'] });
      toast.success('Đã xóa lệnh thi công');
    },
    onError: (err: any) => {
      toast.error(err.message || 'Lỗi khi xóa lệnh thi công');
    }
  });

  const kpis = {
    total: dbWorkOrders.length,
    completed: dbWorkOrders.filter((i: any) => i.status === 'completed').length,
    inProgress: dbWorkOrders.filter((i: any) => i.status === 'in_progress').length,
    notStarted: dbWorkOrders.filter((i: any) => i.status === 'not_started').length,
    paused: dbWorkOrders.filter((i: any) => i.status === 'paused').length,
    overdue: dbWorkOrders.filter((i: any) => i.status === 'overdue').length,
  };

  return {
    workOrders: dbWorkOrders,
    kpis,
    isLoading: isLoadingList,
    deleteWorkOrder: deleteMutation.mutate,
    isDeleting: deleteMutation.isPending,
    error: listError,
  };
}
